import { type ThunkAction, type UnknownAction } from '@reduxjs/toolkit';
import {
  setCurrentOrganization,
  setLoadingOrganization,
  setLoadingOrganizations,
  setOrganizations,
  setPagination,
} from './organizationSlice';

import OrganizationService from '../../infrastructure/services/organization.service';
import { type RootState } from '@/platform/store/types';

export const thunkGetOrganizations =
  ({
    skip,
    limit,
  }: {
    skip: number;
    limit: number;
  }): ThunkAction<void, RootState, unknown, UnknownAction> =>
  async (dispatch) => {
    dispatch(setLoadingOrganizations(true));
    try {
      const data = await OrganizationService.getOrganizations({ skip, limit });
      dispatch(setOrganizations(data?.organizations || []));
      dispatch(
        setPagination({
          skip,
          limit,
          page: Math.floor(skip / limit) + 1,
          total: data?.total || 0,
        }),
      );
    } catch {
      dispatch(setOrganizations([]));
    } finally {
      dispatch(setLoadingOrganizations(false));
    }
  };

export const thunkGetOrganization =
  (): ThunkAction<void, RootState, unknown, UnknownAction> =>
  async (dispatch) => {
    dispatch(setLoadingOrganization(true));
    dispatch(setCurrentOrganization(null));
    try {
      const data = await OrganizationService.getOrganization();
      dispatch(setCurrentOrganization(data));
    } finally {
      dispatch(setLoadingOrganization(false));
    }
  };
